module.exports = __webpack_public_path__ + "static/media/dashboard_item_active.357ffb76.svg";